import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront';

import { AimoCloseAccountComponent } from './aimo-close-account.component';

export const CLOSE_MY_ACCOUNT ='CLOSE_MY_ACCOUNT';

export const closeAccountHistoryLayout: LayoutConfig = {
    launch: {
        CLOSE_MY_ACCOUNT: {
            inlineRoot: true,
            component: AimoCloseAccountComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};
